<template>
  <smart-dialog title="Clore le workshop" :value="value" :width="1000" @input="onDialogInput" transition="dialog-bottom-transition">
    <v-container fluid class="pa-0">
      <v-row dense>
        <v-col class="align-center">
          <v-card flat class="pa-4">
            <v-row dense class="justify-center">
              <v-col cols="2" class="d-flex align-center justify-center">
                <v-icon color="blue darken-2" size="80">mdi-information-slab-box</v-icon>
              </v-col>

              <v-col cols="10">
                <p class="font-weight-medium mb-1 grey--text">Informations</p>
                <p>L'action de clôturer un workshop aura pour conséquence de convertir les nouveaux contacts en agents.</p>
                <p>Le workshop ne pourra plus être modifié une fois clôturé.</p>
                <template v-if="hasUnvalidContact">
                  <p class="mt-1">Chaque <span class="font-weight-medium">contact à compléter</span> doit être rattaché à une agence et disposer d'informations complètes.</p>
                  <p>Une fois les informations d'un contact saisies, confirmer en appuyant sur <span class="caption chip">ENREGISTRER</span>.</p>
                  <p>
                    Naviguez entre ces différents contacts avec
                    <span class="chip"><v-icon small color="grey darken-1">mdi-arrow-left-thin</v-icon></span>
                    et
                    <span class="chip"><v-icon small color="grey darken-1">mdi-arrow-right-thin</v-icon></span>.
                  </p>
                </template>
              </v-col>

              <v-col v-if="draft" cols="12">
                <v-divider class="my-4" />
                <div class="d-flex justify-space-between">
                  <p class="font-weight-medium mb-1 grey--text">Contact à compléter</p>
                  <div class="d-flex align-center">
                    <div class="mr-4 cursor-pointer" @click="shiftUnvalid(-1)">
                      <v-chip small class="cursor-pointer" :disabled="currentIndex <= 0">
                        <v-icon small color="grey darken-1">mdi-arrow-left-thin</v-icon>
                      </v-chip>
                    </div>
                    <p class="font-weight-medium mb-1 grey--text">{{ currentIndex + 1 }}/{{ unvalidContacts.length }}</p>
                    <div class="ml-4 cursor-pointer" @click="shiftUnvalid(1)">
                      <v-chip small class="cursor-pointer" :disabled="currentIndex >= unvalidContacts.length - 1">
                        <v-icon small color="grey darken-1">mdi-arrow-right-thin</v-icon>
                      </v-chip>
                    </div>
                  </div>
                </div>

                <v-form ref="finish-form" v-model="valid">
                  <v-row dense class="px-4 pt-4">
                    <v-col cols="6">
                      <v-text-field dense v-model="draft.firstname" label="Prénom" :rules="rules.nonEmptyTrim()"/>
                    </v-col>
                    <v-col cols="6">
                      <v-text-field dense v-model="draft.lastname" label="Nom" :rules="rules.nonEmptyTrim()"/>
                    </v-col>
                    <v-col cols="6">
                      <v-text-field dense v-model="draft.email" label="Email" :rules="rules.email()"/>
                    </v-col>
                      <v-col  v-if="!draft.agencyId && draft.agencyName" cols="6" >
                        <div class="d-flex align-center justify-center">
                          <v-text-field dense v-model="draft.agencyName"  disabled readonly>
                            <template #label>
                                <span>
                                  <span class="grey--text text--darken-2 mr-2">Nom de l'agence</span> saisie rapide
                                  <v-tooltip right>
                                    <template v-slot:activator="{ on }">
                                      <v-icon v-on="on" small color="grey lighten-1">mdi-information-outline</v-icon>
                                    </template>
                                    <span>Retrouvez l'agence à partir de son nom noté en <span class="font-weight-bold">saisie rapide</span> en appuyant sur <v-icon small color="grey lighten-2">mdi-magnify</v-icon></span>
                                  </v-tooltip>
                                </span>
                            </template>
                          </v-text-field>
                          <div class="cursor-pointer ml-2 mt-2" @click="copyAgencyNameToSearch()">
                            <v-chip small class="cursor-pointer">
                              <v-icon small color="grey darken-1">mdi-magnify</v-icon>
                            </v-chip>
                          </div>
                        </div>
                      </v-col>
                    <v-col cols="6" v-else />
                  </v-row>

                  <p class="font-weight-medium my-4 grey--text">Agence associée</p>

                  <v-row dense class="px-4 dialog-searchbox" :class="{ 'dialog-searchbox-not-finish': !finish.inProgress && !finish.done }">
                    <template v-if="showLockedAgencyField">
                      <v-col cols="6">
                        <v-text-field dense disabled
                            :value="draft.agencyName || (currentSelectedAgency && currentSelectedAgency.name)"
                        />
                      </v-col>

                      <v-col cols="2">
                        <div class="cursor-pointer mt-4" @click="selectAgency(null)">
                          <v-chip small class="cursor-pointer">
                            <v-icon small color="grey darken-1">mdi-close</v-icon>
                          </v-chip>
                        </div>
                      </v-col>
                    </template>

                    <v-col cols="12" v-else>
                      <SmartAgencySearch ref="smart-agency-search" show-idle-as-error can-create
                                         @select="selectAgency" :send-input="sendInput"
                                         @input-received="clearSendInput()"
                      />
                    </v-col>

                    <div class="finish-dialog-draft-actions" >
                      <div class="d-flex justify-end">
                        <smart-btn secondary :disabled="!currentDraftChanged" @click.native="resetCurrentUnvalid">
                          Reinitialiser
                        </smart-btn>
                        <smart-btn class="ml-2" secondary :disabled="!currentCanBeSaved" @click.native="saveCurrentUnvalid">
                          Enregistrer
                        </smart-btn>
                      </div>
                    </div>
                  </v-row>
                </v-form>
              </v-col>

              <v-col v-else cols="12">
                <v-divider class="my-4" />
                <v-row>
                  <v-col cols="2" />
                  <v-col cols="10">
                    <p class="font-weight-medium mb-1 grey--text">Contacts à compléter</p>
                    <p>Tous les contacts du workshop sont complets.</p>
                    <p>Vous pouvez clôturer le workshop sans action supplémentaire.</p>
                  </v-col>
                </v-row>
              </v-col>

            <!--FINISH PROCESS-->
            <v-col v-if="finish.inProgress || finish.done" cols="12">
              <v-divider class="my-4" />
              <v-row>
                <v-col cols="2" class="d-flex align-center justify-center">
                  <v-icon  v-if="finish.done" color="blue darken-2" size="80">mdi-human-male-board-poll</v-icon>
                  <v-progress-circular v-else color="blue darken-2" indeterminate size="64" />
                </v-col>
                <v-col cols="10" v-if="!finish.done">
                  <p class="font-weight-medium mb-1 grey--text">Clôture du workshop en cours...</p>
                  <p>Merci de patienter quelques instant et de ne pas fermer cette fenêtre.</p>
                </v-col>

                <v-col cols="10" v-else>
                  <div v-if="finish.errors.length > 0">
                    <p class="font-weight-medium mb-1 grey--text">Clôture du workshop annulée</p>
                    <p class="font-weight-medium mb-2 red--text">Une erreur est survenue. Merci de conserver et de transmettre le rapport d’erreur ci-dessous.</p>
                    <div class="error-container" v-for="(errorObj, index) in finish.errors" :key="`error-finish-${index}`">
                      <p class="caption font-weight-medium grey--text">Step-{{errorObj.stepValue > 9 ? errorObj.stepValue : `0${errorObj.stepValue}`}} {{errorObj.stepLabel}}</p>
                      <p class="caption grey--text"><span class="red--text">Item :</span> {{errorObj.item}}</p>
                      <p class="caption grey--text"><span class="red--text">Message : </span>{{errorObj.message}}</p>
                    </div>
                  </div>
                  <div v-else>
                    <p class="font-weight-medium mb-1 grey--text">Clôture du workshop effectuée</p>
                    <p class="font-weight-medium blue--text">Le processus s’est déroulé avec succès.</p>
                    <p>Vous pouvez maintenant fermer cette fenêtre.</p>
                  </div>
                </v-col>
              </v-row>


            </v-col>
            </v-row>


          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <template #actions>
      <smart-btn secondary :disabled="finish.inProgress" @click.native="cancelFinish">Annuler</smart-btn>
      <smart-btn primary :disabled="!canFinishWorkshop" @click.native="finishWorkshopConfirm">Clôturer</smart-btn>
      <smart-btn  v-if="finish.done" primary @click.native="cancelFinish">Fermer</smart-btn>
    </template>
  </smart-dialog>
</template>

<script>
import FormMixin from "@/components/mixins/FormMixin"
import SmartAgencySearch from "@/components/commons/SmartAgencySearch.vue"
import { EventBus } from "@/components/commons/event-bus"

export default {
  name: "WorkshopFinishDialog",
  mixins: [FormMixin],
  components: {
    SmartAgencySearch
  },
  props: {
    value: { type: Boolean, required: true },
    unvalidContacts: { type: Array, required: true },
    checkedList: { type: Array, default: () => [] },
    canFinishWorkshop: {type: Boolean, required: true },
    finish: { type: Object, required: true }
  },
  emits: ['input', 'confirm'],
  data: () => ({
    valid: false,
    currentIndex: 0,
    draft: null,
    currentSelectedAgency: null,
    sendInput: null,
  }),
  computed: {
    hasUnvalidContact() {
      return this.unvalidContacts.length > 0
    },
    currentUnvalidContact() {
      if (!this.unvalidContacts.length) return null
      if (this.currentIndex < 0 || this.currentIndex >= this.unvalidContacts.length) return null
      return this.unvalidContacts[this.currentIndex]
    },
    currentIsNowValid() {
      if (!this.draft) return false

      return (this.draft.agencyId || this.currentSelectedAgency)
          && this.draft.firstname && this.draft.firstname.trim().length > 0
          && this.draft.lastname && this.draft.lastname.trim().length > 0
          && this.draft.email && this.draft.email.trim().length > 0
    },
    currentCanBeSaved() {
      return this.currentDraftChanged && this.currentIsNowValid
    },
    currentDraftChanged() {
      const original = this.currentUnvalidContact
      const draft = this.draft

      if (!original || !draft) return false

      return (
          (draft.firstname || "") !== (original.firstname || "") ||
          (draft.lastname || "") !== (original.lastname || "") ||
          (draft.email || "") !== (original.email || "") ||
          (draft.agencyId || null) !== (original.agencyId || null)
      )
    },
    showLockedAgencyField() {
      if (!this.draft) return false
      return !!this.draft.agencyId
    },
  },
  watch: {
    value(val) {
      if (val) {
        this.currentIndex = 0
        this.loadCurrentUnvalidDraft()
      } else {
        this.resetLocalState()
      }
    },
    unvalidContacts() {
      if (!this.value) return

      if (!this.unvalidContacts.length) {
        this.draft = null
        this.currentSelectedAgency = null
        this.valid = false
        return
      }

      const currentDraftId = this.draft && this.draft.id
      const foundIndex = this.unvalidContacts.findIndex(c => c.id === currentDraftId)

      if (!currentDraftId || foundIndex === -1) {
        this.currentIndex = Math.min(this.currentIndex, this.unvalidContacts.length - 1)
        this.loadCurrentUnvalidDraft()
        return
      }

      this.currentIndex = foundIndex

      const refreshed = this.unvalidContacts[foundIndex]
      if (!refreshed) return

      this.draft = {
        ...this.draft,
        workshopId: refreshed.workshopId,
        meetId: refreshed.meetId,
        agentId: refreshed.agentId,
        agencyId: refreshed.agencyId,
        agencyName: refreshed.agencyName,
        firstname: refreshed.firstname || "",
        lastname: refreshed.lastname || "",
        email: refreshed.email || ""
      }
    }
  },
  methods: {
    onDialogInput(val) {
      this.$emit("input", val)
    },
    resetLocalState() {
      this.valid = false
      this.currentIndex = 0
      this.draft = null
      this.currentSelectedAgency = null
    },
    loadCurrentUnvalidDraft() {
      const contact = this.currentUnvalidContact

      if (!contact) {
        this.draft = null
        this.currentSelectedAgency = null
        this.valid = false
        return
      }

      this.draft = {
        id: contact.id,
        workshopId: contact.workshopId,
        meetId: contact.meetId,
        agentId: contact.agentId,
        agencyId: contact.agencyId,
        agencyName: contact.agencyName,
        firstname: contact.firstname || "",
        lastname: contact.lastname || "",
        email: contact.email || ""
      }

      this.currentSelectedAgency = null
      this.valid = false

      this.$nextTick(() => {
        if (this.$refs["finish-form"]) {
          this.$refs["finish-form"].validate()
        }
      })
    },
    copyAgencyNameToSearch() {
      if (this.draft.agencyId || !this.draft.agencyName) { return }
      this.sendInput = this.draft.agencyName
    },
    clearSendInput() {
      this.sendInput = null
    },
    shiftUnvalid(shiftValue = 1) {
      if (!this.unvalidContacts.length) return

      if (this.currentDraftChanged) {
        EventBus.$emit("toaster-msg", "Veuillez actualiser ou réinitialiser le contact actuel")
        return
      }

      this.currentIndex = Math.min(
          Math.max(this.currentIndex + shiftValue, 0),
          this.unvalidContacts.length - 1
      )

      this.loadCurrentUnvalidDraft()
    },
    selectAgency(agency) {
      this.currentSelectedAgency = agency

      if (agency && this.draft) {
        this.draft.agencyId = agency.id
        this.draft.agencyName = agency.name
      }

      if (!agency && this.draft) {
        this.draft.agencyId = null
        this.draft.agencyName = null
      }
    },
    resetCurrentUnvalid() {
      this.loadCurrentUnvalidDraft()
    },
    saveCurrentUnvalid() {
      if (this.$refs["finish-form"]) {
        this.$refs["finish-form"].validate()
      }
      if (!this.currentCanBeSaved) return

      const payload = {
        ...this.draft,
        agencyId: this.draft.agencyId || (this.currentSelectedAgency && this.currentSelectedAgency.id)
      }

      this.$emit("save-contact", payload)
    },
    cancelFinish() {
      this.resetLocalState()
      this.$emit("input", false)
    },
    finishWorkshopConfirm() {
      this.$root
          .$confirm(
              this.$t("confirm"),
              `La clôture du workshop sera définitive. Continuer ?`,
              { width: 450 }
          )
          .then((confirm) => {
            if (!confirm) {
              return Promise.resolve()
            }
            this.finishWorkshop()
          })
    },
    finishWorkshop() {
      this.$emit('confirm')
    }
  }
}
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
  user-select: none;
}

.dialog-searchbox {
  overflow-y: auto;
  position: relative;
}

.dialog-searchbox-not-finish {
  height: 360px;
}

.finish-dialog-draft-actions {
  padding-right: 8px;
  padding-top: 12px;
  position: absolute;
  right: 0;
  top: 0;
}

.error-container {
  margin-bottom: 4px;
  border-bottom: 1px solid red;
}

.chip {
  padding: 2px 4px;
  color: #757575;
  background-color: #E0E0E0;
  border-radius: 8px;
}
</style>